import { AgreementType, type Agreement } from '@/types/info'

export default class AgreementService {
  static data = [
    {
      label: '守擂协议',
      value: AgreementType.ZHUANGYUAN,
    } as const,
    {
      label: '攻擂协议',
      value: AgreementType.NONZHUANGYUAN,
    } as const,
    {
      label: '非协议',
      value: AgreementType.NONAGREEMENT,
    } as const,
  ] as const satisfies readonly Agreement[]
}
